import { reactive } from 'vue'

// 配置对象，最终可以在json-parse中进行引用
const _con:{[prop:string]:any} = reactive({})


export const disposeConfig = {
  _con,
  set(key: string, val: any) {
    _con[key] = val
  },
  delete(key:string) {
    delete _con[key]
  }
}